import { GQLStarTilesFragment } from '@theprintbar/graphql';
import { ImageSize, cn, sizedImage } from '@theprintbar/shared';
import {
	BrandStar,
	ButtonSize,
	Carousel,
	CarouselNextButton,
	CarouselPreviousButton,
	OutlineLinkButton,
	RichText,
	SmallArrowIcon,
} from '@theprintbar/ui';

interface StarTilesProps {
	content: GQLStarTilesFragment;
}

const colours = ['bg-pink', 'bg-yellow', 'bg-green', 'bg-orange'];

export function StarTiles({ content }: StarTilesProps) {
	const tiles = content.starTilesTiles.structure;
	if (!tiles) return null;

	const carouselKey = 'star-tiles';

	return (
		<div className="pl-2 lg:pl-6">
			<Carousel
				carouselKey={carouselKey}
				slidesPerView={1.1}
				breakpoints={{
					640: {
						slidesPerView: 1.5,
					},
					1500: {
						slidesPerView: 2.5,
					},
				}}
				slides={tiles.map((cta, index) =>
					cta
						? {
								containerProps: {
									className: cn('pb-8 px-2 lg:px-4'),
									style: { height: 'auto' },
								},
								content: (
									<div
										className={cn(
											'rounded-3xl border border-blue overflow-hidden lg:flex relative w-full h-full',
											colours[index % colours.length],
										)}
									>
										<div className="p-4 lg:p-12 lg:pr-40 space-y-5 lg:space-y-8 flex flex-col h-full">
											<h4 className="text-base lg:text-lg uppercase">{cta.title}</h4>
											<RichText className="space-y-3 text-sm lg:text-base font-sans" {...cta.text} />

											{cta.links?.map(link =>
												link ? (
													<OutlineLinkButton
														className="w-fit uppercase font-belfast !font-bold text-xs"
														to={link.to || '#'}
														icon={SmallArrowIcon}
														key={link.text}
														iconSize={ButtonSize.S}
													>
														{link.text}
													</OutlineLinkButton>
												) : null,
											)}
										</div>

										<BrandStar
											weight={4}
											image={{
												key: `${carouselKey}-${index}`,
												url: sizedImage(cta?.image?.image.url || '', ImageSize.Medium),
											}}
											rotationAngle={index % 2 === 0 ? 45 : 0} // Specify the desired rotation angle for the star pattern
											className={cn(
												'hidden lg:block absolute right-0 inset-y-0 h-full w-72 xl:w-96 translate-x-1/2 stroke-[0.2] stroke-blue',
											)}
										/>
									</div>
								),
						  }
						: null,
				)}
			>
				<div className="pl-2 lg:pl-2.5 mt-4 lg:mt-8 flex space-x-8">
					<CarouselPreviousButton carouselKey={carouselKey} />
					<CarouselNextButton carouselKey={carouselKey} />
				</div>
			</Carousel>
		</div>
	);
}
